import { render, staticRenderFns } from "./editVariant.vue?vue&type=template&id=5876b1e7"
import script from "./editVariant.vue?vue&type=script&lang=js"
export * from "./editVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports